import { gsap } from '../vendor/gsap';
import { ScrollToPlugin } from '../vendor/gsap/ScrollToPlugin';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';
import addSimpleOpacityAnimation from '../lib/add-simple-opacity-animation';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.text-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const content = query('.text-section-content');
    const pinedBlock = query('.anchor-links ul');
    const pinTrigger = query('.anchor-links');
    const anchorLinks = queryAll('.link-filters, .fn a, .wp-block-footnotes li a');
    const headerContainer = document.querySelector('.header-container');
    const scrollOffset = headerContainer.offsetHeight + 50;
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: sectionElement,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(content, timeline);
    addSimpleOpacityAnimation(timeline, content);

    // Detect if a link's href goes to the current page
    function getHash(link) {
        return link.hash;
    }
    // Scroll to a given hash, preventing the event given if there is one
    function scrollToHash(hash, e) {
        const elem = hash ? document.querySelector(hash) : false;
        if (elem) {
            if (e) e.preventDefault();
            gsap.to(window, 1, {
                scrollTo: {
                    y: elem,
                    offsetY: scrollOffset,
                },
            });
        }
    }
    // If a link's href is within the current page, scroll to it instead
    anchorLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            scrollToHash(getHash(link), e);
        });
    });

    // Scroll to the element in the URL's hash on load
    scrollToHash(window.location.hash);

    if (pinedBlock) {
        gsap.to(pinedBlock, {
            ease: 'none',
            scrollTrigger: {
                trigger: pinTrigger,
                pin: true,
                pinSpacing: false,
                scrub: true,
                start: `top +=${scrollOffset}px`,
                end: `bottom +=${pinedBlock.offsetHeight + scrollOffset}px`,
            },
        });
    }
    const setActiveAnchor = (anchor) => {
        anchorLinks.forEach((link) => {
            link.classList.remove('active');
        });
        anchor.classList.add('active');
    };

    anchorLinks.forEach((anchor) => {
        anchor.addEventListener('click', () => {
            setActiveAnchor(anchor);
        });
    });
};

export { sectionSelector, sectionCallBack };
